import { FC, ReactNode } from 'react'
import { Text } from 'components/Typography'
import { SAction, SHeaderRow, SHeaderRowTabs, SHeaderTab, STabContent, STabs } from './Tabs.styled'
import { InterpolationPrimitive } from '@emotion/serialize'

export type TabSpecification = {
  key: string
  label: ReactNode
  content?: ReactNode | (() => ReactNode)
}

export type TabsProps = {
  tabs: TabSpecification[]
  selectedTabKey: string | undefined
  onTabSelected: (tabKey: string) => void
  className?: string
  action?: ReactNode
  hideTabs?: boolean
  tabContentCss?: InterpolationPrimitive
  swipeable?: boolean
  fullWidthTabs?: boolean
}

export const Tabs: FC<TabsProps> = (props) => {
  const selectedTab = props.tabs.find((tab) => tab.key === props.selectedTabKey)

  return (
    <STabs className={props.className} swipeable={props.swipeable}>
      <SHeaderRow swipeable={props.swipeable}>
        <SHeaderRowTabs
          css={
            props.fullWidthTabs
              ? {
                  width: '100%',
                  '& > *': {
                    flexGrow: 1,
                    textAlign: 'center',
                  },
                }
              : undefined
          }
        >
          {props.tabs.map((tab) => {
            const isSelected = tab.key === props.selectedTabKey
            return (
              <SHeaderTab
                key={tab.key}
                isSelected={isSelected}
                swipeable={props.swipeable}
                onClick={() => props.onTabSelected(tab.key)}
              >
                {typeof tab.label === 'string' ? <Text>{tab.label}</Text> : tab.label}
              </SHeaderTab>
            )
          })}
        </SHeaderRowTabs>

        {props.action && <SAction>{props.action}</SAction>}
      </SHeaderRow>
      {selectedTab?.content && (
        <STabContent css={props.tabContentCss}>
          {typeof selectedTab.content === 'function' ? selectedTab.content() : selectedTab.content}
        </STabContent>
      )}
    </STabs>
  )
}
